var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / MV") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-MV",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Mask-Copy",
    fill: "#F32249",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-1568",
    fill: "#15A04F",
    mask: "url(#mask-2)",
    x: 4,
    y: 4,
    width: 20,
    height: 12,
    rx: 0.666666667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3333333,5.33333333 C15.6764834,5.33333333 16.0109831,5.37037046 16.3330527,5.44066526 C14.2362903,5.89880998 12.6666667,7.76610236 12.6666667,10 C12.6666667,12.2338976 14.2362903,14.10119 16.3328225,14.5591619 C16.0109831,14.6296295 15.6764834,14.6666667 15.3333333,14.6666667 C12.7560045,14.6666667 10.6666667,12.5773288 10.6666667,10 C10.6666667,7.42267117 12.7560045,5.33333333 15.3333333,5.33333333 Z",
    id: "Oval-12",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMv);
export default __webpack_public_path__ + "static/media/MV.530a9a270571de984bae4ee8958f14a3.svg";
export { ForwardRef as ReactComponent };